<template>
	<div class="information-container">
		<!-- Divider -->
		<divider-generic
		:dividerSize="'medium'"
		:applyBorder="!getMobileAppState"
		:icon="'identification'"
		:title="t('userArea.profile.identificationInfoTitle')"/>
		<!-- *********************************************
		*                     User Info                  *
		********************************************** -->
		<text-blocks-generic
		v-for="(block, i) in identificationDataParsedForTextBlock"
		class="info-block"
		:key="`identificationBlock${i}`"
		:params="block"/>
	</div>
</template>

<script setup>
import TextBlocksGeneric from '@/components/generic/textBlocks/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* Assets & Helpers */
import { computed } from 'vue'
import { getDate } from '@/assets/scripts/dateBuilders'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()

/* Props received:
@identificationData { Object }
*/
const props = defineProps({
    identificationData: Object
})

const identificationDataParsedForTextBlock = computed(() => {
	return [{
		label: t('userArea.profile.documentType'),
		content: props.identificationData.documentType ? props.identificationData.documentType : t('emptyFieldState')
	}, {
		label: t('userArea.profile.documentNumber'),
		content: props.identificationData.documentNumber ? props.identificationData.documentNumber : t('emptyFieldState')
	}, {
		label: t('userArea.profile.emissionDate'),
		content: props.identificationData.issueDate ? getDate(props.identificationData.issueDate) : t('emptyFieldState'),
        classes: 'capitalize'
	}, {
		label: t('userArea.profile.expiryDate'),
		content: props.identificationData.expiryDate ? getDate(props.identificationData.expiryDate) : t('emptyFieldState'),
        classes: 'capitalize'
	}]
})
</script>

<style lang="scss" scoped>
.information-container {
	width: 100%;
    max-width: 508px;
    margin-bottom: 24px;

	:deep(.divider-generic-wrapper) {
		margin-bottom: 24px;
	}

	.info-block {
		margin-bottom: 16px;

		&:last-of-type {
			margin-bottom: 0;
		}
	}
}
</style>
